/**
 * Cart Header Button Module
 * Handles cart amount display in header
 */

import { getStorage } from '../core/storage.js';

export class CartHeaderButton {
    constructor(system) {
        this.system = system;
        this.cartButton = null;
        this.cartAmountElement = null;
    }

    init() {
        this.cartButton = document.querySelector('.js-cart');
        this.cartAmountElement = document.querySelector('.js-cart-amount');
        
        // Early return if no cart button elements found - this page doesn't have cart button
        if (!this.cartAmountElement && !this.cartButton) {
            console.log('CartHeaderButton: No cart button elements found, skipping initialization');
            return;
        }

        console.log('CartHeaderButton: Initializing cart button functionality');
        
        if (this.cartAmountElement) {
            this.updateCartAmount();
            this.setupStorageListener();
        }

        // Universal behavior (all tenants): the header cart button opens the
        // inline cart panel instead of navigating to the removed cart page
        if (this.cartButton) {
            this.cartButton.addEventListener('click', (e) => {
                if (this.system.inlineCart) {
                    e.preventDefault();
                    this.system.inlineCart.open(this.cartButton);
                }
            });
        }
    }

    updateCartAmount() {
        if (!this.cartAmountElement) return;
        
        const cartItems = getStorage(this.system.config.storageKey);
        
        // Calculate total items with fallback for missing OrderCount
        const totalItems = cartItems.reduce((sum, item) => {
            const count = item.OrderCount || item.quantity || 0;
            return sum + (isNaN(count) ? 0 : count);
        }, 0);
        
        this.cartAmountElement.textContent = totalItems;
        
        // Lägg till visuell indikator om det finns items
        if (this.cartButton) {
            this.cartButton.classList.toggle('has-items', totalItems > 0);
        }
    }

    setupStorageListener() {
        // Lyssna på storage-ändringar
        window.addEventListener('storage', () => {
            this.updateCartAmount();
        });

        // Lyssna på anpassade events från systemet
        document.addEventListener('cartUpdated', () => {
            this.updateCartAmount();
        });

        // Setup mutation observer för att reagera på DOM-ändringar
        const observer = new MutationObserver(() => {
            this.updateCartAmount();
        });

        // Observer för att se när produkter läggs till
        const cartContainer = document.querySelector('.js-cart-items');
        if (cartContainer) {
            observer.observe(cartContainer, { 
                childList: true, 
                subtree: true 
            });
        }
    }

    // Manuell uppdatering (kan anropas efter cart-ändringar)
    refresh() {
        this.updateCartAmount();
    }
}
